// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Gear = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "m11.967 4.96-.354-.461.845-2.002-1.935-1.117-1.315 1.738-.574-.073a5 5 0 0 0-1.28.003l-.576.076-1.319-1.743-1.935 1.117.85 2.015-.35.461a5 5 0 0 0-.638 1.106l-.224.534-2.17.271v2.234l2.169.271.223.537c.164.396.378.769.638 1.11l.35.461-.847 2.008 1.935 1.117 1.312-1.733.576.076c.428.056.862.056 1.291.001l.576-.075 1.31 1.731 1.935-1.117-.842-1.996.352-.461a5 5 0 0 0 .65-1.125l.223-.536 2.15-.269V6.885l-2.154-.269-.223-.536a5 5 0 0 0-.646-1.118zm1.569.733 1.579.197a1 1 0 0 1 .876.992v2.234a1 1 0 0 1-.876.992l-1.574.197a6.1 6.1 0 0 1-.778 1.348l.617 1.461a1 1 0 0 1-.421 1.255l-1.935 1.117a1 1 0 0 1-1.297-.262l-.96-1.268a6 6 0 0 1-1.549-.001l-.961 1.269a1 1 0 0 1-1.297.262l-1.935-1.117a1 1 0 0 1-.421-1.255l.622-1.475a6 6 0 0 1-.765-1.332l-1.592-.199a1 1 0 0 1-.876-.992V6.882a1 1 0 0 1 .876-.992l1.596-.199a6.2 6.2 0 0 1 .764-1.324l-.625-1.482a1 1 0 0 1 .421-1.255L4.96.513a1 1 0 0 1 1.297.262l.968 1.279a6 6 0 0 1 1.536-.003L9.727.775a1 1 0 0 1 1.297-.262l1.935 1.117a1 1 0 0 1 .421 1.255l-.619 1.467c.318.414.577.866.775 1.341"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 10a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 10m0 1a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Gear);
export default ForwardRef;
